import React, {useState, useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import Switch from "react-switch";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const CardCarProducts = (props) => {
    const { subaccount: {hasTransitSelfServiceSubAccountRequest, isCardlockProductOnly} } = props;
    const {t, i18n} = useTranslation();
    const [hasTransit, setHasTransit] = useState(!hasTransitSelfServiceSubAccountRequest);
    const [checked, setChecked] = useState(isCardlockProductOnly);

    const onChangeHandler = (check) => {
        props.toggleCarProductsChangeHandler(check);
	}

	useEffect( () => {
        if (props.isProductsModalSuccess >= 1) {
            setChecked(!checked);
        }
    }, [props.isProductsModalSuccess]);

    return(
        <form className="form mt-4" onSubmit={(e) => { e.preventDefault(); }}>
            <div className={`input-field toggle toggle--self-service ${hasTransit ? '' : 'toggle--disabled'}`}>
                <label htmlFor="chk_automobile" className="toggle__wrapper label">
                    <div className="control">
                        <Switch
                            onChange={(e) => onChangeHandler(e)}
                            checked={typeof checked !== 'undefined' ? checked : false}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={24}
                            width={46}
                            onColor="#55B545"
                            offColor={hasTransit ? '#EE1B21': '#888888'}
                            disabled={!hasTransit}
                            id="chk_automobile"
                        />
                        <span className="toggle__label">
                            { t('account.cards.management.form.automobile_products_toggle') }
                        </span>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip-top">
                                {t('account.cards.management.form.automobile_products_tooltip')}
                            </Tooltip>}>
                            <div className="btn-info-tooltip btn-info-tooltip--inline btn-info-tooltip--white btn-info-tooltip--bg-transparent">
                                <i className="fal fa-info-circle"></i>
                            </div>
                        </OverlayTrigger>
                    </div>
                </label>
            </div>
        </form>
    );
}

export default CardCarProducts;
